import client from '../../lib/service/system-event.service';

type PostOccurrenceBody = {
  event_type_slug: string;
  event_params?: Record<string, unknown>;
};

export async function postOccurrence(params: PostOccurrenceBody) {
  const response = await client.post('/v1/occurrences/browser', {
    occurrence: params,
  });

  return response.data.occurrence;
}
